import ContractorsPage from "./ContractorsPage";

export default ContractorsPage;
